/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DamageGroupFromJSON, DamageGroupToJSON, ProtocolDamageDetailFromJSON, ProtocolDamageDetailToJSON, } from './';
export function DamageKindDictionaryValueFromJSON(json) {
    return DamageKindDictionaryValueFromJSONTyped(json, false);
}
export function DamageKindDictionaryValueFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'group': !exists(json, 'group') ? undefined : DamageGroupFromJSON(json['group']),
        'name': json['name'],
        'protocolsDamageDetails': !exists(json, 'protocolsDamageDetails') ? undefined : (json['protocolsDamageDetails'] === null ? null : json['protocolsDamageDetails'].map(ProtocolDamageDetailFromJSON)),
    };
}
export function DamageKindDictionaryValueToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'group': DamageGroupToJSON(value.group),
        'name': value.name,
        'protocolsDamageDetails': value.protocolsDamageDetails === undefined ? undefined : (value.protocolsDamageDetails === null ? null : value.protocolsDamageDetails.map(ProtocolDamageDetailToJSON)),
    };
}
